import React, { useState } from "react";
import TooltipItem from "../../TooltipItem";
import { utils } from "../../../utils/utils";
import { Container, Button } from "reactstrap";
import ProgrammingTable from "./ProgrammingTable";
import InformationModal from "../../InformationModal";
import ConfirmationModal from "../../ConfirmationModal";
import ProgrammingDetailsModal from "./ProgrammingDetailsModal";
import { programmingApi } from "../../../services/programmingServices";

const WAITING_FOR_ASSIGNMENT_STATUS = 1;
const WAITING_FOR_PROGRAMMING_STATUS = 2;
const NEW_JOBS_PROGRAMMING_TAB = "NEW_JOBS_PROGRAMMING_TAB";
const WAITING_FOR_PROGRAMMING_TAB = "WAITING_FOR_PROGRAMMING_TAB";
const DEFAULT_TABS_TO_LOAD = [
  NEW_JOBS_PROGRAMMING_TAB,
  WAITING_FOR_PROGRAMMING_TAB,
];

const NewJobs = ({
  programmingTotal,
  setProgrammingTotal,
  setReloadTabs,
  reloadTabs,
  tabName,
}) => {
  const [readOnly, setReadOnly] = useState();
  const [checkerId, setCheckerId] = useState();
  const [programmerId, setProgrammerId] = useState();
  const [programmingStatusId, setProgrammingStatusId] = useState();
  const [programmingSelected, setProgrammingSelected] = useState();
  const [detailModal, setDetailModal] = useState(false);
  const [informationModal, setInformationModal] = useState(
    utils.initInformationModal
  );
  const [confirmationModal, setConfirmationModal] = useState(
    utils.initConfirmationModal
  );

  const columns = [
    {
      id: "assignJobButton",
      accessor: "assignJobButton",
      Header: "Assign Job",
      headerProps: { className: "text-truncate" },
      disableSortBy: true,
      width: 100,
      Cell: (rowData) => {
        return (
          <Button
            className="btn-sm rounded px-1 py-0"
            color={"success"}
            onClick={() => {
              const programming = rowData.row.original;
              setProgrammingSelected(programming);
              setProgrammerId(programming?.programmer?.id || null);
              setCheckerId(programming?.checker?.id || null);
              setDetailModal(true);
            }}
          >
            Assign Job
          </Button>
        );
      },
    },
    {
      id: "sendToProgrammingButton",
      accessor: "sendToProgrammingButton",
      Header: "Send Job",
      headerProps: { className: "text-truncate" },
      disableSortBy: true,
      width: 130,
      Cell: (rowData) => {
        const programming = rowData.row.original;
        const validation = !programming?.programmer || !programming?.checker;
        const tooltipMessage = `Missing assign ${
          !programming?.programmer ? "Programmer" : "Checker"
        }`;
        return (
          <Button
            className="btn-sm rounded px-1 py-0"
            color={"warning"}
            onClick={() => {
              changeProgrammingStatus(programming);
            }}
            disabled={validation}
          >
            <TooltipItem
              className="flex-grow-1"
              id={"tooltip-" + programming?.id}
              title={validation ? tooltipMessage : null}
            >
              Send to Programmer
            </TooltipItem>
          </Button>
        );
      },
    },
    {
      id: "seeJobDetailsButton",
      accessor: "seeJobDetailsButton",
      Header: "Job Details",
      headerProps: { className: "text-truncate" },
      disableSortBy: true,
      width: 125,
      Cell: (rowData) => {
        return (
          <Button
            className="btn-sm rounded px-1 py-0"
            color={"primary"}
            onClick={() => {
              const programming = rowData.row.original;
              const programmer = programming?.programmer;
              const checker = programming?.checker;
              setProgrammingSelected(programming);
              setProgrammerId(
                programmer
                  ? `${programmer?.firstName} ${programmer?.lastName}`
                  : "-"
              );
              setCheckerId(
                checker ? `${checker?.firstName} ${checker?.lastName}` : "-"
              );
              setProgrammingStatusId(programming.programmingStatusId);
              setReadOnly(true);
              setDetailModal(true);
            }}
          >
            See Job Details
          </Button>
        );
      },
    },
  ];

  const onClear = async () => {
    setProgrammerId();
    setCheckerId();
    setProgrammingSelected();
    setDetailModal(false);
    setReadOnly(false);
    setProgrammingStatusId();
    setConfirmationModal(utils.initConfirmationModal);
    setInformationModal(utils.initInformationModal);
  };

  const onSubmit = async (e) => {
    try {
      e.preventDefault();
      setDetailModal(false);
      setConfirmationModal({
        isOpen: true,
        onSubmit: async () => {
          try {
            setReloadTabs([]);
            const data = readOnly
              ? {
                  ...programmingSelected,
                  programmingStatusId,
                }
              : {
                  ...programmingSelected,
                  programmerId,
                  checkerId,
                };
            await programmingApi.updateProgramming(
              programmingSelected.id,
              data
            );
            onClear();
            setInformationModal({
              isOpen: true,
              title: "Programming Update",
              body: "Programming updated successfully.",
            });
            setReloadTabs(
              readOnly
                ? [
                    NEW_JOBS_PROGRAMMING_TAB,
                    utils.programmingTabs[programmingStatusId],
                  ]
                : [NEW_JOBS_PROGRAMMING_TAB]
            );
          } catch (error) {
            onClear();
            setInformationModal({
              isOpen: true,
              title: "Error",
              body: "There was an error with your request.",
            });
          }
        },
        onClose: () => setConfirmationModal(utils.initConfirmationModal),
        title: "Programming Update",
        body: `
          <div class="text-center">
            Do you confirm you want to update the job ${programmingSelected?.job?.jobNumber}?
          </div>
        `,
        confirmColor: "warning",
      });
    } catch (error) {
      onClear();
      setInformationModal({
        isOpen: true,
        title: "Error",
        body: "There was an error with your request.",
      });
    }
  };

  const changeProgrammingStatus = async (programming) => {
    try {
      setDetailModal(false);
      setConfirmationModal({
        isOpen: true,
        onSubmit: async () => {
          setReloadTabs([]);
          await programmingApi.updateProgramming(programming.id, {
            ...programming,
            programmingStatusId: WAITING_FOR_PROGRAMMING_STATUS,
          });
          onClear();
          setInformationModal({
            isOpen: true,
            title: "Send to Programmer",
            body: "Programming sent to Programmer successfully.",
          });
          setReloadTabs(DEFAULT_TABS_TO_LOAD);
        },
        onClose: () => setConfirmationModal(utils.initConfirmationModal),
        title: "Send to Programmer",
        body: `
          <div class="text-center">
            Do you confirm you want to send the job ${programming?.job?.jobNumber} to Programmer?
          </div>
        `,
        confirmColor: "warning",
      });
    } catch (error) {
      setInformationModal({
        isOpen: true,
        title: "Error",
        body: "There was an error with your request.",
      });
    }
  };

  return (
    <Container fluid className="px-0">
      <ProgrammingTable
        columns={columns}
        programmingStatusId={WAITING_FOR_ASSIGNMENT_STATUS}
        setProgrammingTotal={setProgrammingTotal}
        programmingTotal={programmingTotal}
        reloadTabs={reloadTabs}
        tabName={tabName}
      />
      {informationModal.isOpen ? (
        <InformationModal
          title={informationModal.title}
          body={informationModal.body}
          onClose={() => setInformationModal(utils.initInformationModal)}
        />
      ) : confirmationModal.isOpen ? (
        <ConfirmationModal {...confirmationModal} />
      ) : (
        <ProgrammingDetailsModal
          programming={programmingSelected}
          detailModal={detailModal}
          onSubmit={onSubmit}
          onClear={onClear}
          readOnly={readOnly}
          checkerId={checkerId}
          setCheckerId={setCheckerId}
          programmerId={programmerId}
          setProgrammerId={setProgrammerId}
          enableUpdate={readOnly}
          statusId={programmingStatusId}
          setStatusId={setProgrammingStatusId}
        />
      )}
    </Container>
  );
};

export default NewJobs;
